module.exports = __webpack_public_path__ + "img/knot-left.0db06fb5.svg";